import React, { useState, useMemo, useCallback } from 'react';

import {
  CREATIVE_TYPE,
  FILE,
  FILE_GUID,
} from 'scenes/Gallery/GalleryPage/Creatives/constants';

import CopyCreativeFields from './CopyCreativeFieldsContext';

export const CopyCreativeFieldsProvider = ({ children }) => {
  const [state, setState] = useState(null);

  const hasCopyBuffer = useMemo(() => {
    return !!state;
  }, [state]);

  const handleCopy = (creative) => {
    const {
      /* eslint-disable */
      [FILE]: _file,
      [FILE_GUID]: _fileGUID,
      [CREATIVE_TYPE]: creativeType,
      /* eslint-enable */
      ...fields
    } = creative;
    setState(fields);
  };

  const handlePaste = useCallback(
    (callback) => {
      callback(state);
    },
    [state, setState]
  );

  return (
    <CopyCreativeFields.Provider
      value={{ hasCopyBuffer, copy: handleCopy, paste: handlePaste }}
    >
      {children}
    </CopyCreativeFields.Provider>
  );
};
